import { FacebookOnboardingPage } from './dumb.js';
import enhance from './enhancer';

export default enhance(FacebookOnboardingPage);
